'use es6';

import { createContext } from 'react';
export const isWidthMobile = width => width <= 1024;
export const isMon569WidthMobile = width => width <= 1190;
export const IsMobileContext = /*#__PURE__*/createContext(null);